import { render, staticRenderFns } from "./recommend-words.vue?vue&type=template&id=09bf5ec6&scoped=true&lang=pug&"
import script from "./recommend-words.vue?vue&type=script&lang=js&"
export * from "./recommend-words.vue?vue&type=script&lang=js&"
import style0 from "./recommend-words.vue?vue&type=style&index=0&id=09bf5ec6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09bf5ec6",
  null
  
)

export default component.exports